import { gql } from '@apollo/client'

export const MANUFACTURER_FRAGMENT = gql`
  fragment Manufacturer on Manufacturer {
    id
    name
  }
`
